import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import { Box } from '@mui/material';
import { Fragment, useEffect } from 'react';
import { useGDUsMaps } from '/@/hooks/frost-risk';
import { _ } from '/@/locale';
import { formatDate } from '/@/utils';
import Title from '/@/v3/components/title';

import { cardSx } from '..';
import FRReferences from '../components/references';

const GDUMapOverlay = ({ onChangeMap, days, setIsLoading }) => {
    const { data: maps, isValidating } = useGDUsMaps();
    useEffect(() => {
        setIsLoading(isValidating);
    }, [isValidating]);

    useEffect(() => {
        if (maps && maps.length > 0) {
            const map = maps.find(({ duration }) => duration === `${days}d`);
            if (map) onChangeMap(map);
        }
    }, [maps, days]);

    const REFERENCES = [
        { label: days === 7 ? '0 - 14' : '0 - 28', color: '#FF2929' },
        { label: days === 7 ? '14 - 35' : '28 - 70', color: '#EF9E00' },
        { label: days === 7 ? '35 - 70' : '70 - 140', color: '#FBFF25' },
        { label: days === 7 ? '>70' : '>140', color: '#8AE01C' },
    ];

    const today = new Date();
    const endDate = new Date(new Date().setDate(new Date().getDate() + days));
    const dateFrom = formatDate(today, { dayMonthOnly: true });
    const dateTo = formatDate(endDate, { dayMonthOnly: true });

    return (
        <Fragment>
            <Box
                sx={{
                    ...cardSx,
                    display: 'flex',
                    minWidth: 'fit-content',
                    maxWidth: { xs: '200px', md: '250px' },
                    p: 2,
                    alignItems: 'center',
                    zIndex: 1,
                    pointerEvents: 'auto',
                    bottom: '76px',
                }}
            >
                <CalendarMonthOutlinedIcon fontSize='large' sx={{ mr: 1 }} />
                <Title bolder size='md'>
                    {_(`${dateFrom} - ${dateTo}`)}
                </Title>
            </Box>
            <FRReferences
                references={REFERENCES}
                title={_('Cantidad de GDUs por día en los siguientes {{dias}} días', { dias: days })}
                sx={{
                    flexDirection: 'column',
                    maxWidth: { xs: '200px', md: '250px' },
                    alignItems: 'flex-start',
                    zIndex: 1,
                    pointerEvents: 'auto',
                }}
            />
        </Fragment>
    );
};

export default GDUMapOverlay;
